function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function AddClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( ( current == undefined ) || ( current.indexOf( cls ) == -1 ) )
        {
            current += " " + cls;
            el.setAttribute( "class", current );
        }
    }
}
function RemoveClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( current )
        {
            current = current.replace( cls, ' ' );
            el.setAttribute( "class", current );
        }
    }
}

function HasClass( el, cls )
{
    var current = el.getAttribute( "class" );
    return ( ( current != undefined ) && ( current.indexOf( cls ) != -1 ) );
}

//////////////////////////////////////////////////////////////////////////////////////////////////////
// sliders
//////////////////////////////////////////////////////////////////////////////////////////////////////


var maxVelocity       = 10;
var minVelocity       = 5;
var accelerationDelay = 3;

function SetSliderState( row, items, leftIdx, itemsVisible )
{
    var left    = row.querySelector( ".left-arrow" );
    var right   = row.querySelector( ".right-arrow" );
    var maxLeft = items.length - itemsVisible;

    if ( leftIdx == 0 )
    {
        AddClass( left, "opaqued" );
    }
    else
    {
        RemoveClass( left, "opaqued" );
    }
    if ( leftIdx >= maxLeft )
    {
        AddClass( right, "opaqued" );
    }
    else
    {
        RemoveClass( right, "opaqued" );
    }
}

function SlideIntoView( row, itemNumber, itemsVisible )
{
    var slider   = row.querySelector( ".lightning_slider" );
    var items    = slider.querySelectorAll( ".container" ); 
    var item     = items[ itemNumber ];
    var iLeft    = 0 - item.offsetLeft;
    var cLeft    = slider.offsetLeft;
    var delta    = minVelocity;    
    var distance = Math.abs( iLeft - cLeft );
    var counter  = 0;
    var width    = slider.offsetWidth + "px";
    
    // add some nasty hackery
    iLeft += 20;

    function animateRow( )
    {
        var cl = slider.offsetLeft;

        // decide whether going left or right
        if ( iLeft < cLeft )
        {
            cl -= delta;
            if ( cl >= iLeft )
            {
                slider.setAttribute( "style", "left: " + cl + "px" + ";" + "width: " + width );
                window.setTimeout( animateRow, 1 );
            }
            else
            {
                slider.setAttribute( "style", "left: " + iLeft + "px" + ";" + "width: " + width );
                SetSliderState( row, items, itemNumber, itemsVisible );
            }
        }
        else
        {
            cl += delta;
            if ( cl <= iLeft )
            {
                slider.setAttribute( "style", "left: " + cl + "px"  + ";" + "width: " + width );
                window.setTimeout( animateRow, 1 );
            }
            else
            {
                slider.setAttribute( "style", "left: " + iLeft + "px"  + ";" + "width: " + width );
                SetSliderState( row, items, itemNumber, itemsVisible );
            }
        }
        if ( counter++ % accelerationDelay == 0 )
        {
            delta++;
        }
    }
    
    window.setTimeout( animateRow, 1 );
}

function slideRight( button )
{
    DoSlide( button, function( a, b ) { return ( a + b ); } );
}
function slideLeft( button )
{
    DoSlide( button, function( a, b ) { return ( a - b ); } );
}

function DoSlide( button, op )
{
    var row  = button.parentNode;
    var cIdx = row.getAttribute( "data-leftmost" );

    if ( cIdx == undefined )
    {
        cIdx = 0;
    }
    else
    {
        cIdx = Number( cIdx );
    }

    var sliderContainer = row.querySelector( ".slider-container" );
    var slider          = sliderContainer.querySelector( ".lightning_slider" );
    var items           = slider.querySelectorAll( ".container" );
    var lastItem        = items[ items.length - 1 ];
    var lastRight       = lastItem.offsetLeft + lastItem.offsetWidth;
    var relativeRight   = lastRight + slider.offsetLeft;
    var visibleWidth    = sliderContainer.offsetWidth;
    var itemsVisible    = Math.floor( visibleWidth / items[ 0 ].offsetWidth );

    cIdx = op( cIdx, itemsVisible );
    if ( cIdx < 0 )
    {
        cIdx = 0;
    }
    var leftmost = items.length - itemsVisible;
    if ( cIdx > leftmost )
    {
        cIdx = leftmost;
    }

    SlideIntoView( row, cIdx, itemsVisible );
    row.setAttribute( "data-leftmost", cIdx );
}



function InitialiseSliders( )
{
    var sliders = document.querySelectorAll( ".lightning_section-slider" );
    for ( var i = 0; i < sliders.length; i++ )
    {
        var row             = sliders[ i ];
        var sliderContainer = row.querySelector( ".slider-container" );
        var slider          = sliderContainer.querySelector( ".lightning_slider" );
        var items           = slider.querySelectorAll( ".container" );

        //set the width of the slider - would use css but max-content doesn't work on edge
        var width = 0;
        for( var j = 0; j < items.length; j++ )
        {
            var item    = items[ j ];
            var styles  = window.getComputedStyle( item );
            var margin  = parseFloat(styles['marginLeft']) + parseFloat(styles['marginRight']);
            var width   = width + item.offsetWidth + margin + 5;
        }
        slider.style.width = width + "px";
      
        //set padding bottom
        var sliderHeight  = slider.offsetHeight;
        row.style.paddingBottom = sliderHeight + "px";

        if ( items.length > 0 )
        {
            var lastItem        = items[ items.length - 1 ];
            var lastRight       = lastItem.offsetLeft + lastItem.offsetWidth;
            var relativeRight   = lastRight + slider.offsetLeft;
            var visibleWidth    = sliderContainer.offsetWidth;
            var itemsVisible    = Math.floor( visibleWidth / items[ 0 ].offsetWidth );

            SetSliderState( row, items, 0, itemsVisible, width );
        }
    }
}
InitialiseSliders();

// window.onload = function CenterScrollBar()
// {
// 	var slider 			= document.querySelector( "#lightning_section-slider" );
//   	var parent 			= slider.parentNode;
//   	var sliderWidth		= slider.offsetWidth;
//   	var parentWidth		= parent.offsetWidth;
//   	parent.scrollLeft	=( (sliderWidth - parentWidth) /2 );  
// }

///////////////////////////////////////////////////////////////////////////////
//product redirect with variant
//////////////////////////////////////////////////////////////////////////////

function RedirectToProductPage( select )
{
    var options = select.querySelectorAll( "option" );
    var selected = select.selectedIndex;
    
    for( var i = 0; i < options.length; i++ )
    {
        var option = options[ i ];
        if( i == selected )
        {
            var url = option.dataset.url;
            window.location.href = url;
        }
    }   
}